import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Saison sélectionnée au niveau global de l'application (sélecteur unique dans
 * la sidebar). Pilote le filtrage du dashboard, des stats et des équipes.
 *
 * `selectedSeason === null` signifie « pas encore de choix explicite » : les
 * consommateurs retombent alors sur la saison courante (cf. `useActiveSeason`).
 * Le choix explicite de l'utilisateur est mémorisé (localStorage).
 */
interface SeasonState {
  selectedSeason: string | null;
  setSelectedSeason: (season: string) => void;
}

export const useSeasonStore = create<SeasonState>()(
  persist(
    (set) => ({
      selectedSeason: null,
      setSelectedSeason: (season) => set({ selectedSeason: season }),
    }),
    {
      name: 'volley-stats-season',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
